export function identify (userId, traits) {
  import('logrocket').then(({ default: LogRocket }) => {
    LogRocket.identify(userId, traits)
  })
}
